import { makeObservable, observable, action } from "mobx";

import WhoisApi from "../api/WhoisApi";

const foreignLanguageCodes = ["en", "kz", "kg", "uz", "am"];

const LANGUAGE_INFORMER_FEATURE_ID = 233; // prod
// const LANGUAGE_INFORMER_FEATURE_ID = 1311; // staging

class LanguageInformer {
  rootStore;

  baseUrl;

  visible = false;

  api;

  locale;

  constructor(rootStore, baseUrl, locale) {
    this.rootStore = rootStore;
    this.baseUrl = baseUrl;
    this.locale = locale;

    this.api = new WhoisApi();

    makeObservable(this, {
      visible: observable,
      checkVisibility: action,
      closeInformer: action,
      showInformer: action,
    });
  }

  closeInformer = () => {
    const { enabler } = this.rootStore;

    this.visible = false;

    enabler.markAsViewed(LANGUAGE_INFORMER_FEATURE_ID);
  };

  showInformer = () => {
    this.visible = true;
  };

  checkVisibility = async () => {
    const { enabler } = this.rootStore;

    if (this.locale === "ru") {
      return;
    }

    const feature = await enabler.getFeatureById(LANGUAGE_INFORMER_FEATURE_ID);

    if (!feature.is_enabled || feature.is_viewed) {
      return;
    }

    let countryCode;
    try {
      const response = await this.api.getUserCountryLocale();

      if (response.data.country) {
        countryCode = response.data.country.toLowerCase();
      }
    } catch (error) {
      console.error(
        "Header: error while trying to get user country locale. ",
        error
      );

      return;
    }

    if (countryCode && foreignLanguageCodes.includes(countryCode)) {
      this.showInformer();
    }
  };
}

export default LanguageInformer;
